import { render } from "./Extensions.vue?vue&type=template&id=fa484636"
import script from "./Extensions.vue?vue&type=script&lang=ts"
export * from "./Extensions.vue?vue&type=script&lang=ts"
script.render = render

export default script